import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type PageHeaderActionsProps = ComponentProps<"div">

function PageHeaderActions(props: PageHeaderActionsProps) {
  const { className, ...divProps } = props
  return <div className={cn("page-header-actions", className)} {...divProps} />
}

export default PageHeaderActions
